import React from 'react'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Tonality, Modal } from '@dsny/dsny-component-library'
import { Warning, Close } from '@dsny/dsny-component-library/icons'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'
import {
  XButtonWrapper,
  ModalWrapper,
  ModalContainer,
  ModalTitleWrapper,
  ButtonWrapper
} from '../MyNetwork/MyNetwork.styles'
import { StyledModal } from 'components/Modals/Modals.styles'
import { trackEvent } from 'utils/segmentService'

export const UnsavedChangesModal = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isMobile = useMobileMediaQuery()

  return (
    <StyledModal
      $isMobile={isMobile}
      isOpen={isOpen}
      onClose={onClose}
      analyticsModalType="unsaved_changes"
      trackEvent={trackEvent}
      containerStyles={{
        padding: isMobile ? '24px' : '32px',
        ...(isMobile
          ? { borderTop: `8px solid ${theme.colors.alert50}` }
          : { borderLeft: `8px solid ${theme.colors.alert50}` })
      }}
    >
      <XButtonWrapper onClick={onClose}>
        <Close width={24} color={theme.colors.neutralW80} />
      </XButtonWrapper>

      <ModalWrapper $isMobile={isMobile}>
        <ModalContainer $isMobile={isMobile}>
          <Warning width={24} color={theme.colors.alert50} />
          <ModalTitleWrapper $isMobile={isMobile}>
            <Tonality.UIHeading
              headingStyle="headline6"
              color={theme.colors.neutralW100}
              style={{ marginBottom: 8, lineHeight: '1.5rem' }}
            >
              {t('settings.unsaved-changes-modal.title')}
            </Tonality.UIHeading>

            <Tonality.UIText textStyle="label" color={theme.colors.neutralW100}>
              {t('settings.unsaved-changes-modal.body')}
            </Tonality.UIText>
          </ModalTitleWrapper>
        </ModalContainer>

        <ButtonWrapper $isMobile={isMobile}>
          <Tonality.Button
            variant="secondary"
            setting="player"
            mode="dark"
            onClick={onConfirm}
          >
            {t('settings.leave-without-saving')}
          </Tonality.Button>
          <Tonality.Button
            variant="primary"
            setting="player"
            mode="dark"
            onClick={onClose}
          >
            {t('settings.stay-on-page')}
          </Tonality.Button>
        </ButtonWrapper>
      </ModalWrapper>
    </StyledModal>
  )
}
